import { render, staticRenderFns } from "./PeltierEffectViz.vue?vue&type=template&id=2de141a6&scoped=true"
import script from "./PeltierEffectViz.vue?vue&type=script&lang=js"
export * from "./PeltierEffectViz.vue?vue&type=script&lang=js"
import style0 from "./PeltierEffectViz.vue?vue&type=style&index=0&id=2de141a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de141a6",
  null
  
)

export default component.exports